import React from "react";
import { useResource, useNavigation } from "@refinedev/core";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Save } from "lucide-react";
import { PageHeader } from "@/components/ui/page-header";

interface CreatePageProps {
  title?: string;
  children: React.ReactNode;
  saveButtonProps?: React.ButtonHTMLAttributes<HTMLButtonElement> & { loading?: boolean };
  isLoading?: boolean;
  footerButtons?: React.ReactNode;
  headerButtons?: React.ReactNode;
}

export const CreatePage: React.FC<CreatePageProps> = ({
  title,
  children,
  saveButtonProps,
  isLoading,
  footerButtons,
  headerButtons,
}) => {
  const { resource } = useResource();
  const { goBack } = useNavigation();
  const displayTitle = title || `Create ${resource?.meta?.label || resource?.name || ""}`;

  return (
    <div>
      <PageHeader
        title={
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="icon" onClick={goBack} className="-ml-2">
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <span>{displayTitle}</span>
          </div>
        }
        actions={headerButtons}
      />
      <div className="space-y-6">
        {children}
      </div>
      <div className="flex items-center justify-end gap-2 mt-6">
        {footerButtons}
        {saveButtonProps && (
          <Button type="submit" disabled={saveButtonProps.disabled || isLoading} {...saveButtonProps}>
            <Save className="mr-2 h-4 w-4" />
            Save
          </Button>
        )}
      </div>
    </div>
  );
};
